<template>
  <div class="container mt-5 has-text-centered" style="min-height: 300px;">
    <div class="hero">
      <p class="subtitle is-4 mt-5">Authorizing with Twitter...</p>
      <div class="control mt-5 is-loading"></div>
    </div>
  </div>
</template>
<script>

export default {
  name: "AuthStart",
}
</script>

<style lang="scss" scoped>
.control.is-loading {
  position: static;
  &:after {
    position: absolute;
    left: calc(50% - 1rem);
    width: 4rem;
    height: 4rem;
  }
}
</style>
